import { DataBaseComponent } from "./data-base-component.js";

export class DataStringComponent extends DataBaseComponent {
    static webComponentName: string = "data-string";
    protected _templateId: string = "data-string-template"; // Template ID for rendering
    protected inputType: string = "text"; // Default input type for string fields
   
    constructor() {
        super();
    }
    addDataForTemplate(): Record<string, any> {
        const isPassword = this.isPassword();
        return {
            // Add any additional data needed for the template here
            inputType: isPassword ? 'password' : this.inputType, // Pass the input type to the template
            isObject: typeof this.value === 'object' && this.value !== null && this.value !== undefined,
            isPassword
        };
    }

    private isPassword() {
        return this.closest('[password]') !== null;
    }
}
